import { render, staticRenderFns } from "./CartLimitation.vue?vue&type=template&id=8a462d0e&scoped=true"
import script from "./CartLimitation.vue?vue&type=script&lang=js"
export * from "./CartLimitation.vue?vue&type=script&lang=js"
import style0 from "./CartLimitation.vue?vue&type=style&index=0&id=8a462d0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a462d0e",
  null
  
)

export default component.exports